import {Injectable} from '@angular/core';


export class BrowserUtil {
    public isIE11(): boolean {
        return navigator.appName === 'Netscape' && navigator.appVersion.indexOf('Trident') !== -1;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
